import { Device, InstallationItemGatewayDevice } from '@vi-iot/client';

import { RichDevice, isEcoWaterDevice } from '@store';

export function getWallboxDeviceIndex(device: RichDevice): string {
  return device.id.split('eebus-')[1];
}

// Order:
// Gateway / EcoWater
export function sortDevicesInTilesOrder<
  T extends RichDevice | InstallationItemGatewayDevice | Device
>(devices: T[]): T[] {
  const commonDevices = [];
  const ecoWaterDevices = [];
  devices.filter(Boolean).forEach((device) => {
    if (isEcoWaterDevice(device)) {
      return ecoWaterDevices.push(device);
    }
    commonDevices.push(device);
  });

  return [...commonDevices, ...ecoWaterDevices];
}
